export const styles = theme => ({
    title: {
        fontSize: '1.2rem',
        fontWeight: 500,
        textAlign: 'center',
        color: '#292f48',
        marginTop: '2rem',
        marginBottom: '4rem',
    },
    
    adminRole: {
        marginLeft: theme.spacing(1),
        width: 24
    },
    logo: {
        cursor: 'pointer',
        width: '40%',
        maxWidth: 150,
        marginTop: '2rem',
        marginBottom: theme.spacing(6),
    },
});